// Why the user ended up back on the login screen.
//
// App.tsx writes the reason when it handles a session-expired event;
// login.tsx reads it once on mount and shows the matching message. Held
// in sessionStorage rather than router state so it survives the
// navigate() plus any reload in between, and is scoped to this tab —
// a second tab shouldn't inherit another tab's eviction notice.

const KEY = "logoutReason";

export type LogoutReason =
    /** The account signed in on another device; this session was evicted. */
    | "session_superseded"
    /** Session no longer valid for any other reason (expiry, restart). */
    | "session_expired";

export const setLogoutReason = (reason: LogoutReason): void => {
    try { window.sessionStorage.setItem(KEY, reason); } catch { /* ignore */ }
};

/** Reads and clears — the message is shown exactly once. */
export const takeLogoutReason = (): LogoutReason | null => {
    try {
        const stored = window.sessionStorage.getItem(KEY);
        if (stored === null) return null;
        window.sessionStorage.removeItem(KEY);
        return stored === "session_superseded" || stored === "session_expired"
            ? stored
            : null;
    } catch {
        return null;
    }
};
